<template>
  <!-- TOP Nav Bar -->
  <div class="iq-top-navbar" :class="{ 'fixed-header': fixedHeader }">
    <div class="iq-navbar-custom">
      <nav class="navbar navbar-expand-lg navbar-light">
        <!-- ≤1199px yan menü çekmecesini açar (assets/css/sidebar.css). -->
        <button type="button" class="vega-menu-btn" :aria-label="$t('Menu')" :title="$t('Menu')" @click="miniSidebar">
          <i class="fa-regular fa-bars" aria-hidden="true"></i>
        </button>
        <auto-complete data-url="/Customer/AutoComplete"
                       data-hidden-name="LayoutCustomerID"></auto-complete>
        <!-- bootstrap-vue b-navbar-toggle ile aynı DOM -->
        <button type="button" aria-label="Toggle navigation" class="navbar-toggler" v-collapse-toggle="'nav-collapse'">
          <i class="fa-regular fa-ellipsis-vertical fa-lg"></i>
        </button>
        <base-collapse id="nav-collapse" is-nav>
          <slot name="responsiveRight" />
        </base-collapse>
        <slot name="right" />
      </nav>
    </div>
  </div>
  <!-- TOP Nav Bar END -->
</template>
<script>
  import AutoComplete from '../../shared/AutoComplete'

  export default {
    name: 'NavBarStyle',
    emits: ['toggle'],
    components: {
      AutoComplete
    },
    data() {
      return { fixedHeader: false }
    },
    methods: {
      miniSidebar() {
        this.$emit('toggle')
      },
      // Sayfa 75px kayınca üst çubuk sabitlenir (eski `pluginInit.fixedHeader`).
      updateFixedHeader() {
        this.fixedHeader = window.scrollY >= 75
      }
    },
    mounted() {
      document.addEventListener('click', this.closeSearch, true)
      window.addEventListener('scroll', this.updateFixedHeader, { passive: true })
      this.updateFixedHeader()
    },
    beforeUnmount() {
      window.removeEventListener('scroll', this.updateFixedHeader)
    }
  }
</script>
